import { FullPageLoader, MobileVerificationGate } from "@components/index";
import { getLocalStorageData, removeLocalStorageData } from "@picovico/utils";
import { useLazyGetUserProfileQuery } from "@store/services/user";
import { useMounted } from "hooks";
import { ReactElement, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/hooks";
import { logInAction, logOutAction } from "store/slices/userSlice";

function AuthHandler({ children }: { children: ReactElement }) {
  const mounted = useMounted();
  const { isInitialized, isLoggedIn } = useAppSelector((state) => state.user);
  const [getProfile, { isLoading }] = useLazyGetUserProfileQuery({});
  const dispatch = useDispatch();

  useEffect(() => {
    const init = () => {
      const token = getLocalStorageData("token");

      if (token) {
        getProfile({
          headers: {
            Authorization: token,
          },
        })
          .unwrap()
          .then((res) => {
            res.data && dispatch(logInAction(res.data));
          })
          .catch((err) => {
            console.log("error");
            // A 401 means the stored token is dead; keeping it would make
            // every later request (even public ones) get rejected.
            if (err?.status === 401) removeLocalStorageData("token");
            dispatch(logOutAction());
          });
      } else {
        dispatch(logOutAction());
      }
    };
    if (!isLoggedIn) {
      init();
    }
  }, [getProfile, dispatch, isLoggedIn, isInitialized]);

  if (!mounted || !isInitialized || isLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      {children}
      <MobileVerificationGate />
    </>
  );
}

export default AuthHandler;
